/**
 * Centralised web routes — maps mobile RoomsTemplate navigation targets to web URLs.
 *
 * Mobile screen           →  Web route
 * BreatheScreen           →  /web/breathe                 (CalmRoom cushion)
 *  ↳ {isDance:true}       →  /web/breathe?mode=dance      (PlayRoom disco)
 *  ↳ {isMusic:true}       →  /web/breathe?mode=music      (CalmRoom music)
 * KidsJournal             →  /web/journal                 (CalmRoom journal)
 * TravelPlanScreen/Intro  →  /web/planner                 (HomeRoom planner/gift)
 * MyWall                  →  /web/my-wall                 (HomeRoom bouncy frame)
 * MyJourneyScreen         →  /web/appJourneyPage          (HomeRoom balloon)
 * MagicBagPack            →  /web/magic-backpack          (HomeRoom video, PlayRoom stories)
 * ChatBoxScreen           →  /web/chatbox?mode=chat       (HomeRoom chat) — isChatBox=true on mobile
 *  ↳ Tell-a-story         →  /web/chatbox?mode=story      (PlayRoom mic)  — isChatBox=false on mobile
 * Doodling                →  /web/doodling                (PlayRoom doodle board)
 * StarBoardScreen         →  /web/star-board              (top-right star button)
 */
export const webRoutes = {
  heartCorner:    "/web/rooms?openHeart=true",
  breathe:        "/web/breathe",
  breatheDance:   "/web/breathe?mode=dance",
  breatheMusic:   "/web/breathe?mode=music",
  journal:        "/web/journal",
  planner:        "/web/planner",
  myWall:         "/web/my-wall",
  journey:        "/web/appJourneyPage",
  magicBackpack:  "/web/magic-backpack",
  chatbox:        "/web/chatbox?mode=chat&navigatedFrom=hometemplate",
  chatboxStory:   "/web/chatbox?mode=story&navigatedFrom=hometemplate",
  doodling:       "/web/doodling",
  jokes:          "/web/jokes",
  starBoard:      "/web/star-board",
  rooms:          "/web/rooms",
  grownup:        "/web/grownup",
  questScreen:    "/web/quest",
  chatWithTroo:   "/web/chatWithTroo"
} as const;

export type WebRouteKey = keyof typeof webRoutes;
